import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AccordionGroupContext, AccordionContext } from '../../context';

const AccordionGroup = ({ children, itemId }) => {
  const { appearance } = useContext(AccordionContext);

  const classes = classNames('ws-ui-accordion-group', `ws-ui-accordion-group--${appearance}`);

  return (
    <AccordionGroupContext.Provider value={itemId}>
      <div className={classes}>{children}</div>
    </AccordionGroupContext.Provider>
  );
};

AccordionGroup.propTypes = {
  itemId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AccordionGroup;
